import { select } from 'd3-selection';
import store from '../../store';
import { changeCurrentKey, changeCurrentScale } from '../../actions/index';
import dictionary from './dict';
import renderLegend from './legend';
import render from './render';
import { scroll } from '../../helpers/util';

const { getState, dispatch } = store;
const filters = document.querySelector('.filtros');
const filterLeft = filters.querySelector('.filtros__esquerda');
const filterRight = filters.querySelector('.filtros__direita');

export default () => {
  const { initial } = getState();
  const { list, scales } = initial;
  const { NEWDATA } = list;
  const { municipios, candidatos, total } = NEWDATA;

  // TEMPLATE
  const appendVencedores = param => (
    param.map((item, i) => (
      (
        `${i === 0 ? '<option value="">Selecione um candidato</option>' : ''}
          <option value=${item.numero_candidato}>
            ${item.nome_candidato} (${item.sigla_partido})
          </option>`
      )
    )).join('')
  );

  // TEMPLATE
  const appendMunicipios = param => Object.keys(param).map((item, i) => (
    `${i === 0 ? '<option value="">Selecione um município</option>' : ''}
      <option value=${item}>${param[item].municipio}</option>`
  )).join('');

  // HANDLER
  function handlerLeft({ target }) {
    const attr = target.getAttribute('tipo');
    const { value } = target;
    const active = document.querySelector('.path__municipio.active');
    if (active) {
      active.classList.remove('active');
    }

    if (attr === 'municipio' && value) {
      const pathActive = document.querySelector(`[data-id='${value}']`);
      select(pathActive)
        .dispatch('mouseover')
        .dispatch('mousemove');
      scroll('.geografia__voto__container');
    }

    if (!value) {
      const over = new Event('mouseout');
      active.dispatchEvent(over);
    }
  }

  // HANDLER
  function handlerRight({ target }) {
    const { value } = target;
    const app = document.querySelector('.mapa');
    const key = target.getAttribute('key');
    const { scaleCandidatos } = scales;

    if (!value) {
      dispatch(changeCurrentKey({
        key: 'candidatos',
        target: 'id_candidato',
        type: null,
        tooltip: 'candidatos',
      }));
      dispatch(changeCurrentScale(scaleCandidatos()));
      app.innerHTML = '';
      render();
      renderLegend();
      return;
    }

    dispatch(changeCurrentKey({
      key: 'candidatos',
      target: 'total_percentual',
      type: 'individual',
      param: value,
      tooltip: 'individual',
    }));

    dispatch(changeCurrentScale(dictionary(key)));
    app.innerHTML = '';
    render();
    renderLegend();
  }

  // EVENT LISTENER
  const leftItem = filterLeft.querySelectorAll('select');
  [...leftItem].forEach((item) => {
    item.addEventListener('change', handlerLeft);
  });

  // EVENT LISTENER
  const rightItem = filterRight.querySelectorAll('select');
  [...rightItem].forEach((item) => {
    item.addEventListener('change', handlerRight);
  });

  // FILL FILTERS

  const removed = total.candidatos.filter(item => parseInt(item.total_votos_validos, 10));
  const newCandidatos = removed.map(item => candidatos[item.id_candidato])
    .sort((a, b) => a.nome_candidato.localeCompare(b.nome_candidato));
  filterLeft.querySelector('select[tipo=municipio]').innerHTML = appendMunicipios(municipios);
  filterRight.querySelector('select[tipo=candidato]').innerHTML = appendVencedores(newCandidatos);
};

export function clearFiltes() {
  const allInputs = filterLeft.querySelectorAll('select, input');
  [...allInputs].forEach((item) => {
    item.value = '';
    const tipo = item.getAttribute('tipo');
    if (tipo !== 'uf') {
      item.setAttribute('disabled', true);
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/mapa/filters.js